import styled from "styled-components";

export const RowCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
  gap: 10px;
`;

export const ColCard = styled.div`
  flex: 1 1 ${({ colCount }) => 100 / (colCount || 3) - 2}%;
  max-width: ${({ colCount }) => 100 / (colCount || 3) - 2}%;
  margin: 10px 0;
  display: flex;
  flex-direction: column;

  @media (max-width: 992px) {
    flex: 1 1 ${({ colCount }) => (colCount && colCount > 2 ? 50 : 100 / (colCount || 3) - 2)}%;
    max-width: ${({ colCount }) => (colCount && colCount > 2 ? 50 : 100 / (colCount || 3) - 2)}%;
  }

  @media (max-width: 576px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;
